<overlay-scrollbars class="h-100 bg-white" [options]="scrollOptions">
    <div #myRankingContainer class="my-ranking-container" [ngClass]="{'layout-large': widgetSize === WidgetSize.Large, 'layout-medium': widgetSize === WidgetSize.Medium, 'layout-small': widgetSize === WidgetSize.Small}">
        <div class="my-ranking-card" *ngFor="let myRank of data">
            <cxone-my-ranking-card [myRank]="myRank"></cxone-my-ranking-card>
        </div>
    </div>
</overlay-scrollbars>